import { Award, Heart, Gem } from 'lucide-react';

// Badge colors mapping
const BADGE_COLORS = {
  pink: 'bg-pink-100 text-pink-600 border-pink-200',
  blue: 'bg-blue-100 text-blue-600 border-blue-200',
  amber: 'bg-amber-100 text-amber-700 border-amber-200',
  gray: 'bg-gray-100 text-gray-600 border-gray-300',
  yellow: 'bg-yellow-100 text-yellow-600 border-yellow-300',
  emerald: 'bg-emerald-100 text-emerald-600 border-emerald-200',
  red: 'bg-red-100 text-red-600 border-red-200'
};

// Badge icons mapping
const BADGE_ICONS = {
  heart: Heart,
  award: Award,
  gem: Gem
};

const BadgeDisplay = ({ badge, size = 'md' }) => {
  const Icon = BADGE_ICONS[badge.icon] || Award;
  const colorClass = BADGE_COLORS[badge.color] || BADGE_COLORS.blue;
  
  const sizeClasses = {
    sm: 'w-6 h-6 text-xs',
    md: 'w-8 h-8 text-sm',
    lg: 'w-10 h-10 text-base'
  };
  
  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };

  return (
    <div 
      className={`inline-flex items-center justify-center rounded-full border ${colorClass} ${sizeClasses[size]}`}
      title={`${badge.name} - ${badge.description}`}
    >
      <Icon className={iconSizes[size]} />
    </div>
  );
};

const BadgeList = ({ badges, size = 'md', showLabels = false }) => {
  if (!badges || badges.length === 0) return null;
  
  return (
    <div className="flex items-center gap-1 flex-wrap">
      {badges.map((badge) => (
        <div key={badge.id} className="flex items-center gap-1">
          <BadgeDisplay badge={badge} size={size} />
          {showLabels && (
            <span className="text-xs text-muted-foreground">{badge.name}</span>
          )}
        </div>
      ))}
    </div>
  );
};

const BadgeCard = ({ badge }) => {
  const Icon = BADGE_ICONS[badge.icon] || Award;
  const colorClass = BADGE_COLORS[badge.color] || BADGE_COLORS.blue;
  
  return (
    <div className={`p-3 rounded-xl border ${colorClass} flex items-center gap-3`}>
      <div className="w-12 h-12 rounded-full flex items-center justify-center bg-white/50">
        <Icon className="w-6 h-6" />
      </div>
      <div>
        <p className="font-medium">{badge.name}</p>
        <p className="text-xs opacity-75">{badge.description}</p>
        {badge.count !== undefined && (
          <p className="text-xs font-medium mt-1">{badge.count} consultations</p>
        )}
      </div>
    </div>
  );
};

export { BadgeDisplay, BadgeList, BadgeCard, BADGE_COLORS, BADGE_ICONS };
